
            const data = {"name":"glyph/12/calendar","data":{"width":"12","height":"12","viewBox":"0 0 12 12","data":"<path pid=\"0\" d=\"M11 2h-1V0H8v2H4V0H2v2H1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-1 8H2V5h8Z\" class=\"nc-icon-wrapper\" _fill=\"#272c33\"/>","originalColors":[{"type":"fill","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    